var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "stats",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.566,
    height: 43.567,
    viewBox: "0 0 43.566 43.567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2118",
    "data-name": "Trazado 2118",
    d: "M9.984,38.121a4.538,4.538,0,0,1-4.538-4.538V2.723A2.723,2.723,0,0,0,2.723,0h0A2.723,2.723,0,0,0,0,2.723v30.86a9.984,9.984,0,0,0,9.984,9.984h30.86a2.723,2.723,0,0,0,2.723-2.723h0a2.723,2.723,0,0,0-2.723-2.723Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2119",
    "data-name": "Trazado 2119",
    d: "M20.723,25.338a2.723,2.723,0,0,0,2.723-2.723V11.723a2.723,2.723,0,1,0-5.446,0V22.615A2.723,2.723,0,0,0,20.723,25.338Z",
    transform: "translate(14.675 7.338)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2120",
    "data-name": "Trazado 2120",
    d: "M8.723,25.338a2.723,2.723,0,0,0,2.723-2.723V11.723a2.723,2.723,0,1,0-5.446,0V22.615A2.723,2.723,0,0,0,8.723,25.338Z",
    transform: "translate(4.892 7.338)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2121",
    "data-name": "Trazado 2121",
    d: "M14.723,29.414a2.723,2.723,0,0,0,2.723-2.723V6.723a2.723,2.723,0,1,0-5.446,0V26.691A2.723,2.723,0,0,0,14.723,29.414Z",
    transform: "translate(9.783 3.261)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.ac9ef2659f3924b320ea687fdee26f62.svg";
export { ForwardRef as ReactComponent };